/**
 * Cookie auth is opt-in until the backend prerequisites documented in
 * docs/features/authentication/cookie-authentication.md are deployed and
 * verified.
 */
export const isCookieAuthenticationEnabled =
  import.meta.env.VITE_AUTH_MODE === 'cookie'
